import { grey } from "@mui/material/colors";
import img from "assets/discover/va_blur_2.png";

const styles = {
  main: {
    backgroundImage: `url(${img})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "98%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    px: { xs: 4, md: 10 },
    borderRadius: 4,
    overflowY: "auto",
  },
  leftSidebar: {
    borderTopLeftRadius: 16,
    borderBottomLeftRadius: 16,
    borderTopRightRadius: { xs: 16, md: 0 },
    borderBottomRightRadius: { xs: 16, md: 0 },
    backgroundColor: "#f5f5f5",
    p: 3,
    overflowX: "hidden",
  },
  header: {
    fontSize: { xs: 25, md: 30 },
    mb: 2,
    lineHeight: 1.5,
  },
  mainHeader: {
    color: "purple.dark",
    fontSize: { xs: 30, md: 35 },
  },
  rightSidebar: (isMediumScreen: boolean) => ({
    display: "flex",
    alignItems: "center",
    p: isMediumScreen ? 6 : 3,
  }),
  image: (discoverTabOpen: boolean) => ({
    width: { xs: 300, md: discoverTabOpen ? 300 : "50vh" },
  }),
  chip: {
    backgroundColor: "white",
    border: `1px solid ${grey[300]}`,
    px: 2,
    py: 1,
    borderRadius: 4,
    fontSize: 10,
    height: "max-content",
    width: "max-content",
  },
};

export default styles;
